import { getApi } from './util/getApi';

const fetchURL = process.env.REACT_APP_API_URL + '/program';
export const api = getApi(fetchURL);


export const createProgram = (data: {
  program_name: string,
  program_description: string,
  causeIds?: Array<number>
} ) =>
  api.post('/insertDocument', data).then(r => r.data);


export const getProgramByProgramId = ( data: { 
  program_id: number 
}) =>
  api.post("/retrieveDocument", data).then((r) => r.data);

  export const getProgramListByUserID = ( data: { 
    user_id: number 
  }) =>
    api.post("/retrieveDocumentByUser", data).then((r) => r.data);